module.exports = __webpack_public_path__ + "static/img/rainfarn.38bdc0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/rainfarn.png
// module id = yNWP
// module chunks = 0